import React, { useEffect } from 'react';
// import Head from 'next/head';

import Grid from '@material-ui/core/Grid';

import FullRow from './ui/blocks/FullRow';
import FullRowMiddle from './ui/blocks/FullRowMiddle';
import LineBreak from './ui/blocks/LineBreak';

import teach from '../assets/images/learn/teach.gif';
import teachCompany from '../assets/images/learn/teachCompany.gif';
import moshavere from '../assets/images/learn/moshavere.gif';
import backup from '../assets/images/learn/backup.gif';

export default function Learn(props) {
    const content = props.content.learn;
    const language = props.language;

    const setValue = props.setValue;
    const setSelectedIndex = props.setSelectedIndex;
    useEffect(() => {
        window.scrollTo(0, 0);
        setValue(1);
        setSelectedIndex(2);
    }, [setValue, setSelectedIndex]);

    return (
        <React.Fragment>
            {/* <Head>
                <title key="title">شبکه عصر دانش آرا</title>
                <meta name="description" key="description" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
                <meta property="og:title" key="og:title" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
            </Head> */}

            <Grid container direction="column" dir={language === "per" ? "rtl" : null} style={{ marginTop: "-5em" }}>

                {/* Header */}
                <FullRow content={content.header} image={teach} language={language} dir={0} imageW={450} />
                <LineBreak height="75px" type={0} />

                {/* First row */}
                <FullRowMiddle content={content.firstRow} image={teachCompany} language={language} imageW={350} />
                <LineBreak height="75px" type={1} />

                {/* Second row */}
                <FullRow content={content.secondRow} image={moshavere} language={language} dir={0} imageW={350} />
                <LineBreak height="75px" type={0} />

                {/* Third row */}
                <FullRowMiddle content={content.thirdRow} image={backup} language={language} />
                <LineBreak height="75px" type={1} />

                {/* Forth row */}
                <FullRow content={content.forthRow} language={language} dir={0} />

                {/* Fifth row */}
                {/* <FullRow content={content.fifthRow} language={language} dir={0} imageW={350} imageH={350} /> */}

            </Grid>
        </React.Fragment>
    )
}